import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toast_config = {
  position: "top-center", // Use string "top-center" for the position
  autoClose: 2000,
  hideProgressBar: true,
  newestOnTop: false,
  rtl: false,
  theme: "colored",
  limit: 1,
  style: {
    fontSize: "17px",
    marginTop: "20px",
  },
};

export { toast_config };
